import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router";
import plutosLogo from "../../assets/icons/plutosLogo.svg";
import CryptoJS from "crypto-js";
import "./Sidebar.scss";
import decryptedModulesData from "../../utils/decryptedModules";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = sessionStorage.getItem("biller_access");

  const [selectedKey, setSelectedKey] = useState("/");

  const permissions = decryptedModulesData()?.modules || [];

  // Filter out Activity Logs if not internal and not super admin
  const filteredMenuItems = [{ label: "Overview", key: "/" }, ...permissions];

  useEffect(() => {
    if (!token) {
      window.location.href = "/login";
      return null;
    }
    setSelectedKey(location.pathname);
  }, [token, location.pathname]);

  return (
    <div className="AppSidebar">
      <Menu
        selectedKeys={[selectedKey]}
        defaultSelectedKeys={["/"]}
        onClick={(item) => navigate(item.key.toLowerCase())}
        items={
          Array.isArray(filteredMenuItems) &&
          filteredMenuItems.filter(item => item?.type!=='AI')?.map((item) => ({
            label: item?.label || item?.module,
            key: item?.key,
          }))
        }
      />
      <div className="plutos-logo">
        <img src={plutosLogo} alt="logo" />
      </div>
    </div>
  );
}

export default Sidebar;
